import React from "react";
import BaseCard from "./BaseCard";

const COLUMNS = 3;

const InfoCard = ({ title, badge, actions, items, children }) => {
  const lastLineStart = items ? items.length - (items.length % COLUMNS || COLUMNS) : 0;

  return (
    <BaseCard className="py-2 px-4 sm:px-6 rounded-lg" elevation={1}>
      <div className="bg-light px-4 py-2 mt-2 mb-2 rounded-md flex justify-between items-center">
        <div className="flex items-center gap-3">
          <h6 className="text-dark font-normal">{title}</h6>
          {badge}
        </div>
        {actions && <div className="flex items-center gap-3">{actions}</div>}
      </div>

      <div className="px-4 pb-2">
        {items && (
          <div className="grid grid-cols-1 lg:grid-cols-3 lg:gap-x-10">
            {items.map(([label, value], i) => (
              <div
                key={label}
                className={`flex flex-col md:flex-row md:items-center gap-1 pb-2 pt-4 ${
                  i === items.length - 1 ? "" : "border-b"
                } ${i >= lastLineStart ? "lg:border-b-0" : ""}`}
              >
                <p className="font-normal text-sm md:w-36 xl:w-52 shrink-0">{label}</p>
                <p className="text-sm min-w-0 break-words">{value || "-"}</p>
              </div>
            ))}
          </div>
        )}
        {children}
      </div>
    </BaseCard>
  );
};

export default InfoCard;
